import { useCallback } from 'react';

import { type GasCorePayload, type GasPureScreenEventPayload } from '@atlaskit/analytics-gas-types';
import { FabricChannel } from '@atlaskit/analytics-listeners';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

interface GasV3UIEventPayload extends GasCorePayload {
	eventType: 'ui';
}

interface GasV3TrackEventPayload extends GasCorePayload {
	eventType: 'track';
}

interface GasV3OperationalEventPayload extends GasCorePayload {
	eventType: 'operational';
}

interface GasV3ScreenEventPayload extends GasPureScreenEventPayload {
	eventType: 'screen';
}

export const usePlatformInstrumentation = (
	{ channel }: { channel?: FabricChannel } = { channel: FabricChannel.elements },
) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const sendUIEvent = useCallback(
		(payload: GasV3UIEventPayload) => {
			createAnalyticsEvent(payload).fire(channel);
		},
		[channel, createAnalyticsEvent],
	);

	const sendTrackEvent = useCallback(
		(payload: GasV3TrackEventPayload) => {
			createAnalyticsEvent(payload).fire(channel);
		},
		[channel, createAnalyticsEvent],
	);

	const sendOperationalEvent = useCallback(
		(payload: GasV3OperationalEventPayload) => {
			createAnalyticsEvent(payload).fire(channel);
		},
		[channel, createAnalyticsEvent],
	);

	const sendScreenEvent = useCallback(
		(payload: GasV3ScreenEventPayload) => {
			createAnalyticsEvent(payload).fire(channel);
		},
		[channel, createAnalyticsEvent],
	);

	return {
		sendUIEvent,
		sendTrackEvent,
		sendOperationalEvent,
		sendScreenEvent,
	};
};
